import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#b7410e',
            },
            dark: {
                primary: '#b7410e',
            }
        }
    }
});
